/* eslint-disable */
import React, {Component} from 'react'
import axios from 'axios'
import {validationMobile, validationNationalId} from '../../validation/validation'
import '../../style/shop.css'
import {MDBAlert} from 'mdbreact'
import jMoment from 'moment-jalali'
import moment from 'moment-jalali'

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'mdbreact'
import {withRouter} from 'react-router-dom'
import {MDBCollapse} from 'mdbreact'
import $ from 'jquery'
import {message} from 'antd'
import {geoLocationIds} from '../BaseComponent/geoLocationIds'
import Loader from '../loaders/loader'
import {accounting} from 'accounting'
// import {Map, Marker, TileLayer} from "react-leaflet";
import {DecryptionText} from '../Base/decryptionText'

const token = 'e2619eb0-17a9-41d7-8ad1-919863da4d13'

class PhoneShop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productInfo: {},
      current: 0,
      progressValue: 33.33,
      imageProduct: '',
      deliveryPacks: [],
      deliveryTitle: '',
      NationalId: '',
      FirstName: '',
      LastName: '',
      Password: '',
      recipientName: '',
      addressText: '',
      geoIds: [],
      selectedAddress: '',
      myAddresses: [],
      userId: '',
      userMobile: '',
      decodeMobile: '',
      latLngAddress: {
        lat: null,
        lng: null
      },
      firstUnit: 1,
      secondUnit: 1,
      mainUnitDecimal: '',
      secondUnitDecimal: '',
      finalObject: {
        DTPlanId: ''
      },
      quantityObject: {
        MinOQ: null,
        MaxComputedOQ: null,
        SecondUnitMinOQ: null,
        SecondUnitMaxOQ: null
      },
      deliveryMethodID: '',
      FeaturedImage: '',
      latLngMarker: ['', ''],
      Qty: 1
    }
  }

  componentDidMount() {
    let urlParams = new URLSearchParams(window.location.search)
    let msisdn = urlParams.get('msisdn') === null ? '' : urlParams.get('msisdn')
    if (DecryptionText(msisdn)) {
      this.setState({
        userMobile: DecryptionText(msisdn),
        decodeMobile: DecryptionText(msisdn)
      })
    } else {
      this.setState({
        decodeMobile: ''
      })
    }

    $(function() {
      $('.header').hide()
    })

    let {id} = this.props.match.params
    axios
      .get(`https://beroozmart.com/api/products/getbyid?id=${id}`, {
        crossdomain: true
      })
      .then((respond) => {
        let nextDate = moment()
          .add(1, 'day')
          .format('jYYYY/jM/jD')
        // alert(JSON.stringify(respond.data.DeliveryDetails.DeliverableTimes[0].DeliveryMethod.DeliveryMethodID))
        this.setState({
          productInfo: respond.data,
          imageProduct: respond.data.OtherImagesList[0],
          deliveryPacks: respond.data.DeliveryDetails.DeliverableTimes[0].Plans.filter(
            (item) => item.PersianDate !== nextDate
          ),
          deliveryTitle: respond.data.DeliveryDetails.DeliverableTimes[0].DeliveryMethod,
          mainUnitDecimal: respond.data.ProductUnit.IsDecimal,
          mainProductUnitId: respond.data.ProductUnit.ProductUnitID,
          secondUnitDecimal: respond.data.SecondUnit !== null && respond.data.SecondUnit.IsDecimal,
          secondProductUnitId: respond.data.SecondUnit !== null && respond.data.SecondUnit.ProductUnitID,
          StockProductID: respond.data.StockProductID,
          quantityObject: {
            MinOQ: respond.data.MinOQ,
            MaxComputedOQ: respond.data.MaxComputedOQ,
            SecondUnitMinOQ: respond.data.SecondUnitMinOQ,
            SecondUnitMaxOQ: respond.data.SecondUnitMaxOQ
          },
          deliveryMethodID: respond.data.DeliveryDetails.DeliverableTimes[0].DeliveryMethod.DeliveryMethodID,
          TDP: respond.data.TDP,
          FeaturedImage: respond.data.FeaturedImage
        })
        console.log(respond.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  nextStep = () => {
    let current = this.state.current
    if (current === 1) {
      let userMobile = document.getElementById('userMobile').value.trim()
      if (userMobile === '') {
        message.error('شماره موبایل خود را وارد کنید')
      } else {
        this.checkExistUser(this.state.userMobile)
      }
    } else if (current === 2) {
      this.setState({
        loadingShop: true
      })
      let myAddresses = this.state.myAddresses.find((item) => item.checked === true)
      if (myAddresses) {
        let data = {
          UserId: this.state.userId,
          recipientID: myAddresses.RecipientID,
          deliveryMethodID: this.state.deliveryMethodID,
          paymentMethodId: 4,
          allowPayViaCredit: false,
          paperInvoice: false,
          packItems: [
            {
              SPID: this.state.StockProductID,
              PUID: this.state.finalObject.PUId,
              DTPlanID: this.state.finalObject.DTPlanId
            }
          ],
          basketModel: {
            items: [
              {
                SPID: this.state.StockProductID,
                PUID: this.state.finalObject.PUId,
                Qty: this.state.Qty
              }
            ]
          }
        }

        axios({
          method: 'post',
          url: 'https://beroozmart.com/api/basket/CreateInvoiceByAdmin?token=' + token,
          data: data
        })
          .then((res) => {
            let Iid = res.data.Iid

            message.success('ثبت سفارش با موفقیت انجام شد.لطفا صبر کنید')
            this.setState({
              loadingShop: false
            })
            setTimeout(() => {
              window.location.assign('https://beroozmart.com/pay?iid=' + Iid + '&pmid=11')
            }, 2000)
          })
          .catch((err) => {
            this.setState({
              loadingShop: false
            })
            message.error(JSON.stringify(err))
          })
      } else {
        message.error('یک آدرس را انتخاب کنید')
      }
    }
  }

  selectDeliveryPack = (num, checked) => {
    let deliveryPacks = this.state.deliveryPacks
    for (let i in deliveryPacks) {
      deliveryPacks[i].checked = false
    }
    deliveryPacks[num].checked = !checked
    this.setState({
      deliveryPacks
    })
  }

  clickOnMap = (e) => {
    let lat = e.latlng.lat
    let lng = e.latlng.lng

    let latLngAddress = {
      lat,
      lng
    }
    axios
      .get(`https://api.neshan.org/v1/reverse?lat=${lat}&lng=${lng}`, {
        headers: {
          'Api-Key': 'service.tDyHKnFkOkYeabYPKdnrZvuA4Aq4c1jFESmpf2K4'
        }
      })
      .then((respond) => {
        let addresstext = respond.data.city + ' - ' + respond.data.neighbourhood + ' - ' + respond.data.address

        this.setState({
          latLngAddress,
          addressText: addresstext,
          latLngMarker: [lat, lng]
        })
      })
  }

  addAddress = () => {
    let address = this.state.addressText
    let FullName = this.state.recipientName
    let Coordinates = this.state.latLngAddress
    let GeoLocationId = document.getElementById('GeoLocationId').value
    let Mobile = document.getElementById('Mobile').value
    if (address === '' || FullName === '' || GeoLocationId === '' || Mobile === '') {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (!validationMobile(Mobile)) {
      message.error('شماره موبایل وارد شده معتبر نیست')
    } else {
      let data = {
        UserId: this.state.userId,
        Address: address,
        Coordinates: `${Coordinates.lat},${Coordinates.lng}`,
        FullName: FullName,
        GeoLocationID: Number(GeoLocationId),
        Mobile: Mobile
      }
      console.log(data)

      axios({
        method: 'post',
        url: 'https://beroozmart.com/api/recipients/admincreate?token=e2619eb0-17a9-41d7-8ad1-919863da4d13',
        data: data
      })
        .then((res) => {
          message.success('آدرس  جدید با موفقیت ثبت شد')
          let userId = this.state.userId
          this.setState({
            modalAddAddres: false
          })
          this.getAllAddress(userId)
        })
        .catch((err) => {})

      // this.setState({
      //     modalAddresses:false
      // })
    }
  }

  changeCity = (e) => {
    let value = e.target.value
    if (value !== '') {
      let findGeo = geoLocationIds.filter((item) => Number(item.ParentID) === Number(value))
      this.setState({
        geoIds: findGeo
      })
    } else {
      this.setState({
        geoIds: []
      })
    }
    // alert(value)
  }

  changeInputs = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }

  registerUser = () => {
    let {FirstName, LastName, userMobile, NationalId, Password} = this.state

    if (FirstName === '' || LastName === '' || userMobile === '' || NationalId === '' || Password === '') {
      message.error('همه فیلد هارا تکمیل کنید')
    } else if (!validationNationalId(NationalId)) {
      message.error('کد ملی وارد شده معتبر نیست')
    } else {
      this.setState({
        loading: true
      })
      let data = {
        Mobile: userMobile,
        FirstName,
        LastName,
        NationalID: NationalId,
        Password
      }

      axios({
        url: 'https://beroozmart.com/api/users/admincreate?token=' + token,
        method: 'post',
        data: data
      })
        .then((res) => {
          this.setState({
            userId: res.data.id,
            progressValue: 100,
            current: this.state.decodeMobile === '' ? this.state.current + 1 : 2,
            modalAddAddres: true,
            loading: false,
            modalRegister: false
          })
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
          if (err.response.request.responseText) {
            let errCode = err.response.request.responseText
            if (errCode.includes('40125')) {
              message.error('کد ملی قبلا ثبت شده است')
            }
          } else {
            message.error(JSON.stringify(err))
          }
          // console.log(1,err.response.request)
          // console.log(2,err.response.request.responseText)
          // console.log(3,err.response.responseText)
          // message.error(JSON.stringify(err))
        })
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  checkExistUserByKey = (userMobile) => {
    axios
      .get(
        `https://beroozmart.com/api/users/exists?mobile=${userMobile}&token=e2619eb0-17a9-41d7-8ad1-919863da4d13`,
        {}
      )
      .then((respond) => {
        let userId = respond.data.Id
        this.setState({
          userId: respond.data.Id,
          progressValue: 100,
          current: 2
        })
        this.getAllAddress(userId)
      })
      .catch((err) => {
        this.setState({
          modalRegister: true
        })
      })
  }

  checkExistUser = (userMobile) => {
    // let {userMobile} = this.state;
    if (this.convertDigit(userMobile) == '') {
      message.error('شماره موبایل را وارد کنید')
    } else if (!validationMobile(this.convertDigit(userMobile))) {
      message.error('شماره همراه صحیح را وارد کنید')
    } else {
      axios
        .get(
          `https://beroozmart.com/api/users/exists?mobile=${userMobile}&token=e2619eb0-17a9-41d7-8ad1-919863da4d13`,
          {}
        )
        .then((respond) => {
          let userId = respond.data.Id
          this.setState({
            userId: respond.data.Id,
            progressValue: 100,
            current: this.state.current + 1
          })
          this.getAllAddress(userId)
        })
        .catch((err) => {
          this.setState({
            modalRegister: true
          })
        })
    }
  }

  getAllAddress = (userId) => {
    axios({
      method: 'get',
      url: `https://beroozmart.com/api/recipients/admingetall?id=${userId}&token=e2619eb0-17a9-41d7-8ad1-919863da4d13`
    })
      .then((res) => {
        if (res.data.length > 0) {
          this.setState({
            myAddresses: res.data,
            modalAddAddres: false
          })
        } else {
          this.setState({
            modalAddAddres: true,
            myAddresses: res.data
          })
        }
        // alert(JSON.stringify(res))
      })
      .catch((err) => {})
  }

  changeFirstUnit = (e, isDecimal) => {
    let value = e.target.value

    if (!isDecimal) {
      if (!value.match(/^[1-9]\d*$/g)) {
        console.log('no')
        this.setState({
          firstUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          firstUnit: Number(value),
          Qty: Number(value)
        })
      }
    } else {
      if (!value.match(/^[1-9]\d*(\.\d+)?$/g)) {
        console.log('no')
        this.setState({
          firstUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          firstUnit: Number(value),
          Qty: Number(value)
        })
      }
    }
  }

  changeSecondUnit = (e, isDecimal) => {
    let value = e.target.value

    if (!isDecimal) {
      if (!value.match(/^[1-9]\d*$/g)) {
        console.log('no')
        this.setState({
          secondUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          secondUnit: Number(value),
          Qty: Number(value)
        })
      }
    } else {
      if (!value.match(/^[1-9]\d*(\.\d+)?$/g)) {
        console.log('no')
        this.setState({
          secondUnit: 1,
          Qty: 1
        })
      } else {
        this.setState({
          secondUnit: Number(value),
          Qty: Number(value)
        })
      }
    }
  }

  goLoginPage = (productValue, PUId) => {
    let find = this.state.deliveryPacks.find((item) => item.checked === true)
    let MinOQ = this.state.quantityObject.MinOQ
    let MaxComputedOQ = this.state.quantityObject.MaxComputedOQ
    // let SecondUnitMinOQ = this.state.quantityObject.SecondUnitMinOQ
    // let SecondUnitMaxOQ = this.state.quantityObject.SecondUnitMaxOQ
    if (!find) {
      message.error('بازه تحویل از جدول زیر انتخاب شود ')
    } else if (MinOQ !== null && productValue < MinOQ) {
      message.error(`حداقل باید ${MinOQ} تعداد سفارش داده شود`)
    } else if (MaxComputedOQ !== null && productValue > MaxComputedOQ) {
      message.error(`حداکثر باید ${MaxComputedOQ} تعداد سفارش داده شود`)
    }
    // else if(SecondUnitMinOQ !== null && productValue < SecondUnitMinOQ){
    //     message.error(`حداقل باید ${SecondUnitMinOQ} تعداد سفارش داده شود`)
    // }
    // else if(SecondUnitMaxOQ !== null && productValue > SecondUnitMaxOQ){
    //     message.error(`حداکثر باید ${<SecondUnitMaxOQ></SecondUnitMaxOQ>} تعداد سفارش داده شود`)
    // }
    else {
      if (this.state.decodeMobile === '') {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID
        finalObject.PUId = PUId
        finalObject.SPId = this.state.StockProductID
        finalObject.productValue = productValue
        this.setState({
          finalObject,
          current: 1,
          progressValue: 66.66
        })
      } else {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID
        finalObject.PUId = PUId
        finalObject.SPId = this.state.StockProductID
        finalObject.productValue = productValue
        this.setState({
          finalObject
        })
        this.checkExistUserByKey(this.state.decodeMobile)
      }
    }
  }

  goLoginPageBySecoundUnit = (productValue, PUId) => {
    let find = this.state.deliveryPacks.find((item) => item.checked === true)
    // let MinOQ = this.state.quantityObject.MinOQ
    // let MaxComputedOQ = this.state.quantityObject.MaxComputedOQ
    let SecondUnitMinOQ = this.state.quantityObject.SecondUnitMinOQ
    let SecondUnitMaxOQ = this.state.quantityObject.SecondUnitMaxOQ
    if (!find) {
      message.error('بازه تحویل از جدول زیر انتخاب شود ')
    } else if (SecondUnitMinOQ !== null && productValue < SecondUnitMinOQ) {
      message.error(`حداقل باید ${SecondUnitMinOQ} تعداد سفارش داده شود`)
    } else if (SecondUnitMaxOQ !== null && productValue > SecondUnitMaxOQ) {
      message.error(`حداکثر باید ${SecondUnitMaxOQ} تعداد سفارش داده شود`)
    }

    // else if(MinOQ !== null && productValue < MinOQ){
    //     message.error(`حداقل باید ${MinOQ} تعداد سفارش داده شود`)
    // }
    // else if(MaxComputedOQ !== null && productValue > MaxComputedOQ){
    //     message.error(`حداکثر باید ${MaxComputedOQ} تعداد سفارش داده شود`)
    // }
    else {
      if (this.state.decodeMobile === '') {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID
        finalObject.PUId = PUId
        finalObject.SPId = this.state.StockProductID
        finalObject.productValue = productValue
        this.setState({
          finalObject,
          current: 1,
          progressValue: 66.66
        })
      } else {
        let finalObject = this.state.finalObject
        finalObject.DTPlanId = find.DTPlanID
        finalObject.PUId = PUId
        finalObject.SPId = this.state.StockProductID
        finalObject.productValue = productValue
        this.setState({
          finalObject
        })
        this.checkExistUserByKey(this.state.decodeMobile)
      }
    }
  }

  setAddress = (num, checked) => {
    let myAddresses = this.state.myAddresses
    for (let i in myAddresses) {
      myAddresses[i].checked = false
    }
    myAddresses[num].checked = !checked
    this.setState({
      myAddresses
    })
  }

  render() {
    let {productInfo} = this.state
    let position = [this.state.latLngAddress.lat, this.state.latLngAddress.lng]

    let stepData = [
      {
        title: 'انتخاب محصول',
        content: (
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-4 p-0 position-relative">
                {this.state.deliveryPacks.length === 0 && (
                  <div className="no-provider-label text-center position-absolute d-flex flex-row justify-content-center align-items-center align-content-center">
                    <span className="p-3 faghede-barname-tamin">فاقد برنامه تامین</span>
                  </div>
                )}

                <img
                  className={this.state.deliveryPacks.length !== 0 ? 'image-product' : 'NotFoundProductOverLay'}
                  src={'https://beroozmart.com/' + this.state.FeaturedImage}
                  width="100%"
                />
              </div>
              <div className="col-12 col-md-8">
                <section className="productTitle mt-3 mt-md-0">
                  <h5 className="font-weight-bold mx-2">{productInfo.Title && productInfo.Title}</h5>
                </section>
                {this.state.deliveryPacks.length !== 0 && (
                  <section className="select-product">
                    {productInfo.TDP && productInfo.TDP !== 0 && (
                      <>
                        <span style={{fontSize: '1.2em'}} className="text-muted pbd-price position-relative mx-2">
                          <span className="khat position-absolute" />
                          {'قیمت قبلی : ' + accounting.formatMoney(productInfo.PBD / 10, '', ',') + ' تومان '}
                        </span>
                        <span className="discount">
                          <span className="discountText d-inline-block p-2">تخفیف</span>
                          <span className="discountVal d-inline-block p-2">{productInfo.TDP + ' % '}</span>
                        </span>
                      </>
                    )}
                    <span className="d-block font-weight-bold mx-2" style={{fontSize: '1.4em'}}>
                      {'قیمت هر ' +
                        (productInfo.ProductUnit && productInfo.ProductUnit.Title) +
                        ' ' +
                        accounting.formatMoney(productInfo.PAD / 10, '', ',') +
                        ' تومان '}
                    </span>
                  </section>
                )}
                <hr className="my-1" />
                {this.state.deliveryPacks.length !== 0 && (
                  <section className="count-product-sec">
                    <div className="d-flex flex-row">
                      <button
                        onClick={() => this.goLoginPage(this.state.firstUnit, this.state.mainProductUnitId)}
                        className="add-product-btn small py-2"
                      >
                        ثبت کالا و مرحله بعد
                      </button>
                      <input
                        type="number"
                        onInput={(e) => this.changeFirstUnit(e, this.state.mainUnitDecimal)}
                        value={this.state.firstUnit}
                        name="firstUnit"
                        min={1}
                        defaultValue={1}
                        className="form-control count-text mx-2"
                      />
                      <p className="mx-3 mt-2 mb-0 align-middle">
                        {productInfo.ProductUnit && productInfo.ProductUnit.Title}
                      </p>
                    </div>
                    {productInfo.SecondUnit !== null && (
                      <div className="d-flex flex-row mt-3">
                        <button
                          className="add-product-btn small py-2"
                          onClick={() =>
                            this.goLoginPageBySecoundUnit(this.state.secondUnit, this.state.secondProductUnitId)
                          }
                        >
                          ثبت کالا و مرحله بعد
                        </button>
                        <input
                          type="number"
                          min={1}
                          onInput={(e) => this.changeSecondUnit(e, this.state.secondUnitDecimal)}
                          value={this.state.secondUnit}
                          name="secondUnit"
                          className="form-control count-text mx-2"
                        />
                        <p className="mx-3 mt-2 mb-0 align-middle">
                          {productInfo.SecondUnit && productInfo.SecondUnit.Title}
                        </p>
                      </div>
                    )}
                  </section>
                )}
                {this.state.deliveryPacks.length === 0 && (
                  <MDBAlert color="danger">در حال حاضر این محصول وجود ندارد</MDBAlert>
                )}
                <hr className="my-1" />
                {this.state.deliveryPacks.length !== 0 && (
                  <section>
                    <div className="card">
                      <div className="card-header text-center">
                        <span className="text-center font-weight-bold">انتخاب بازه تحویل</span>
                      </div>
                      <div className="card-body">
                        <table className="table table-sm table-striped w-100">
                          {/*<thead>*/}
                          {/*<tr>*/}
                          {/*    <th className='text-center'>روز</th>*/}
                          {/*    <th className='text-center'>بازه تحویل</th>*/}
                          {/*    <th className='text-center'>انتخاب</th>*/}
                          {/*</tr>*/}
                          {/*</thead>*/}
                          <tbody>
                            {this.state.deliveryPacks.map((del, index) => (
                              <tr onClick={() => this.selectDeliveryPack(index, del.checked)}>
                                <td className="text-center">
                                  <span className="d-block font-weight-bold small text-dark"> {del.WeekDay}</span>
                                  <span className="d-block font-weight-bold small text-muted">{del.PersianDate}</span>
                                </td>
                                <td className="text-center">
                                  <span className="d-inline-block font-weight-bold p-2 text-muted">
                                    ساعت {del.From.substr(0, 5)} تا{del.To.substr(0, 5)}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <img
                                    className="mt-2"
                                    src={
                                      del.checked
                                        ? require('../../image/checkradio.svg')
                                        : require('../../image/uncheckradio.svg')
                                    }
                                    width="20px"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                )}
              </div>
              <div className="col-12 p-0" />
            </div>
          </div>
        )
      },
      {
        title: 'مشخصات کاربر',
        content: (
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="m-auto">
                  <label>شماره موبایل</label>
                  <input
                    type="text"
                    name="userMobile"
                    placeholder="09xxxxxxxxx"
                    id="userMobile"
                    defaultValue={this.state.userMobile}
                    onChange={this.changeInputs}
                    className="form-control w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        )
      },
      {
        title: 'انتخاب آدرس و پرداخت',
        content: (
          <div className="container">
            <div className="card">
              <div className="card-header">
                {this.state.modalAddAddres ? (
                  <span className="small font-weight-bold">ثبت آدرس جدید</span>
                ) : (
                  <button
                    className="btn btn-sm btn-info"
                    onClick={() =>
                      this.setState({
                        modalListAddress: false,
                        modalAddAddres: true
                      })
                    }
                  >
                    ثبت آدرس جدید
                  </button>
                )}
              </div>
              <MDBCollapse id="basicCollapse" isOpen={!this.state.modalAddAddres}>
                <div className="card-body">
                  <table className="table table-bordered deliveryPackTable">
                    <thead>
                      <tr>
                        <th className="text-center text-dark font-weight-bold">ردیف</th>
                        <th className="text-center text-dark font-weight-bold">آدرس</th>
                        <th className="text-center text-dark font-weight-bold">تحویل گیرنده</th>
                        <th className="text-center text-dark font-weight-bold">انتخاب</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.myAddresses.map((item, index) => (
                        <tr>
                          <td className="text-center">
                            <span className="d-block font-weight-bold small text-dark">{index + 1}</span>
                          </td>
                          <td className="text-center">
                            <span className="d-inline-block font-weight-bold text-muted">{item.Address}</span>
                          </td>
                          <td>
                            <span className="d-inline-block font-weight-bold text-muted">{item.FullName}</span>
                          </td>
                          <td className="text-center" onClick={() => this.setAddress(index, item.checked)}>
                            <img
                              className="mt-2"
                              src={
                                item.checked
                                  ? require('../../image/checkradio.svg')
                                  : require('../../image/uncheckradio.svg')
                              }
                              width="20px"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </MDBCollapse>
              <MDBCollapse id="basicCollapse" isOpen={this.state.modalAddAddres}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12 addressMap mb-2">
                      {/* <Map center={[35.6892,51.3890]} zoom={12}
                                             onClick={this.clickOnMap}
                                        >
                                            <TileLayer

                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                            <Marker position={this.state.latLngMarker}>

                                            </Marker>
                                        </Map> */}

                      {/*<Map*/}
                      {/*    google={this.props.google}*/}
                      {/*    zoom={11}*/}
                      {/*    initialCenter={{*/}
                      {/*        lat: 35.6892,*/}
                      {/*        lng: 51.3890*/}
                      {/*    }}*/}
                      {/*    onClick={this.clickOnMap}*/}
                      {/*>*/}
                      {/*    <Marker*/}
                      {/*        position={{lat: this.state.latLngAddress.lat, lng: this.state.latLngAddress.lng}}>*/}
                      {/*    </Marker>*/}
                      {/*</Map>*/}
                    </div>
                    <div className="col-sm-12">
                      <label>
                        آدرس :<span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <textarea
                        id="locAddress"
                        name="addressText"
                        value={this.state.addressText}
                        onChange={this.changeInputs}
                        className="form-control w-100"
                        style={{minHeight: '150px'}}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label>
                        شهر :<span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <select className="form-control" onChange={this.changeCity}>
                        <option value="">------</option>
                        {geoLocationIds
                          .filter(
                            (item) =>
                              item.GeoLocationID === 4131 ||
                              item.GeoLocationID === 4135 ||
                              item.GeoLocationID === 4540 ||
                              item.GeoLocationID === 4127
                          )
                          .map((geo, index) => (
                            <option value={geo.GeoLocationID}>{geo.Title}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <label>
                        منطقه :<span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <select className="form-control" id="GeoLocationId">
                        <option value="">------</option>
                        {this.state.geoIds.map((item, index) => (
                          <option value={item.GeoLocationID}>{item.Title}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-6">
                      <label>
                        تحویل گیرنده
                        <span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <input type="text" onChange={this.changeInputs} name="recipientName" className="form-control" />
                    </div>
                    <div className="col-sm-6">
                      <label>
                        شماره موبایل
                        <span className="font-weight-bold text-danger mx-2">*</span>
                      </label>
                      <input
                        type="text"
                        onChange={this.changeInputs}
                        name="Mobile"
                        id="Mobile"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer p-4">
                  <div className="row">
                    <div className="col-12">
                      <button className="confirmBtnModal" onClick={this.addAddress}>
                        ثبت آدرس
                      </button>
                      <button className="cancelBtnModal mx-3" onClick={() => this.setState({modalAddAddres: false})}>
                        لغو
                      </button>
                    </div>
                  </div>
                </div>
              </MDBCollapse>
            </div>
          </div>
        )
      }
    ]

    return (
      <div className="position-relative" style={{marginTop: '-70px'}}>
        {/*<div className='w-100 py-2 px-0 px-md-3 text-center text-md-left' style={{background:'#b2d234'}}>*/}
        {/*    <img src={require('../../image/orangLogo.png')} width='200px'/>*/}
        {/*</div>*/}
        <div className="p-3 p-md-0 mt-2">
          <div className="container p-0">
            <div className="row">
              <div className="col-12 pb-0">
                <ul className="p-0 mt-1 w-100 step-shop d-flex flex-row">
                  {stepData.map((item, index) => (
                    <li className="d-inline-block">
                      <div
                        className={
                          index <= this.state.current
                            ? 'circle-step active-circle-step m-auto text-center d-flex flex-row justify-content-center align-items-center'
                            : 'circle-step m-auto text-center d-flex flex-row justify-content-center align-items-center'
                        }
                      >
                        <span>{index + 1}</span>
                      </div>
                      <p className="mt-1 mb-0 font-weight-bold">{item.title}</p>
                    </li>
                  ))}
                </ul>
              </div>
              {/*<div className='col-12 customProgress'>*/}
              {/*    <MDBProgress value={this.state.progressValue} className="" />*/}
              {/*</div>*/}
            </div>
          </div>
          <div className="p-3 body-step container bg-white position-relative">
            {this.state.loadingShop && (
              <div className="loading-shop d-flex flex-row justify-content-center align-items-center align-content-center">
                <p className="font-weight-bold">در حال اتصال به بانک</p>
              </div>
            )}

            {stepData[this.state.current].content}
          </div>
          {this.state.current !== 0 && !this.state.modalAddAddres && (
            <div className={'footer-step mt-2 container'}>
              <div className="container py-3">
                <div className="row">
                  <div className="col-12 p-0 d-flex flex-row justify-content-between">
                    <button
                      disabled={this.state.loadingShop}
                      onClick={this.nextStep}
                      className="confirmBtnModal font-weight-bold mx-3"
                    >
                      {this.state.current === stepData.length - 1 ? 'پرداخت' : 'مرحله بعد'}
                    </button>
                    {this.state.current !== 0 && (
                      <button
                        className="cancelBtnModal font-weight-bold"
                        style={{marginLeft: '15px'}}
                        onClick={() =>
                          this.setState({
                            current: this.state.current - 1,
                            progressValue: this.state.progressValue - 33.33
                          })
                        }
                      >
                        مرحله قبل
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <Modal isOpen={this.state.modalRegister} toggle={() => this.setState({modalRegister: false})} size="lg">
          <ModalHeader toggle={() => this.setState({modalRegister: false})}>ثبت نام</ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />
            <div className="w-100">
              <p className="text-danger text-center font-weight-bold">
                شماره موبایل شما در سیستم وجود ندارد.لطفا فرم زیر را برای ثبت نام تکمیل کنید
              </p>
            </div>
            <hr className="mb-0" />
            <div className="container-fluid">
              <div className="row justify-content-between">
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">نام</label>
                  <input type="text" name="FirstName" className="form-control w-100" onChange={this.changeInputs} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">نام خانوادگی</label>
                  <input type="text" name="LastName" className="form-control w-100" onChange={this.changeInputs} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">کد ملی</label>
                  <input type="text" name="NationalId" className="form-control w-100" onChange={this.changeInputs} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <label className="font-weight-bold text-dark">کلمه عبور</label>
                  <input type="password" name="Password" className="form-control w-100" onChange={this.changeInputs} />
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="confirmBtnModal" onClick={this.registerUser}>
              ثبت نام
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({modalRegister: false, modalLogin: true})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default PhoneShop
//
// export default withRouter(GoogleApiWrapper({
//     apiKey: ('AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw')
// })(PhoneShop))
